// constants
import { showErrorAlert, showSuccessAlert } from "../../constants/alerts";
import { CourseActionTypes } from "./constants";

const INIT_STATE = {
  course: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface courseData {
  id: number;
  name: string;
  categoryId: string;
  amount: string;
}

interface CourseActionType {
  type:
    | CourseActionTypes.API_RESPONSE_SUCCESS
    | CourseActionTypes.API_RESPONSE_ERROR
    | CourseActionTypes.CREATE_COURSE
    | CourseActionTypes.UPDATE_COURSE
    | CourseActionTypes.GET_COURSE
    | CourseActionTypes.UPDATE_COURSE_ENROLLMENT
    | CourseActionTypes.DELETE_COURSE;
  payload: {
    actionType?: string;
    data?: courseData | {};
    error?: string;
    course?: [];
  };
}

interface State {
  course?: courseData[] | [];
  loading?: boolean;
  value?: boolean;
}

const CourseStates = (
  state: State = INIT_STATE,
  action: CourseActionType
): any => {
  switch (action.type) {
    case CourseActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case CourseActionTypes.CREATE_COURSE: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CourseActionTypes.GET_COURSE: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            course: action.payload.data,
          };
        }
        case CourseActionTypes.UPDATE_COURSE: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CourseActionTypes.DELETE_COURSE: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CourseActionTypes.UPDATE_COURSE_ENROLLMENT: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case CourseActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case CourseActionTypes.CREATE_COURSE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case CourseActionTypes.UPDATE_COURSE: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case CourseActionTypes.GET_COURSE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case CourseActionTypes.DELETE_COURSE: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case CourseActionTypes.UPDATE_COURSE_ENROLLMENT: {
          showErrorAlert(action.payload.error);
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case CourseActionTypes.CREATE_COURSE:
      return { ...state, loading: true };
    case CourseActionTypes.UPDATE_COURSE:
      return { ...state, loading: true };
    case CourseActionTypes.GET_COURSE:
      return { ...state, loading: true, initialLoading: true };
    case CourseActionTypes.DELETE_COURSE:
      return { ...state, loading: true };
    case CourseActionTypes.UPDATE_COURSE_ENROLLMENT:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default CourseStates;
